import { useEffect, useState } from 'react';
import { getConsentForm, getConsentFormByOps } from 'api/paymentSetup';
import { ConsentForm, ConsentFormType } from 'types/paymentSetup';
import { DefaultPaymentPolicies, DefaultTreatmentConsent, DefaultHipaaConsent } from 'pages/PaymentSetup/components/ConsentFormsStep/polices';

const initData: ConsentForm[] = [
    {
        type: ConsentFormType.PAYMENT_CANCELLATION,
        content: DefaultPaymentPolicies,
    },
    {
        type: ConsentFormType.TREATMENT_CONSENT,
        content: DefaultTreatmentConsent,
    },
    {
        type: ConsentFormType.HIPAA_PRIVACY,
        content: DefaultHipaaConsent,
    },
];
export const useConsentForm = (isOps: boolean, providerId?: number): [ConsentForm[], boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<ConsentForm[]>(initData);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = isOps ? await getConsentFormByOps(providerId!) : await getConsentForm();
            if (!result.error) {
                const data: ConsentForm[] = result?.data?.data || initData;
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
